module.exports = __webpack_public_path__ + "img/Butterfly_00361.24172869.png";